import {Component, Input} from '@angular/core';
import {BaseSelect2Component} from './base-select2.component';
import {Select2Service} from '../../services/common/select2.service';

@Component({
  selector: 'app-common-select2',
  templateUrl: './base-select2.component.html',
  styleUrls: ['./base-select2.component.scss'],
})
export class CommonSelect2Component extends BaseSelect2Component {
  @Input() link: string;
  @Input() selectId: string;
  @Input() selectName: string;
  @Input() option: string;

  constructor(protected commonService: Select2Service) {
    super(commonService, '');
  }

  protected async getData(): Promise<any> {
    return this.commonService.getCustomList(this.link, this.selectId, this.selectName).toPromise();
  }
}
